// extracted by mini-css-extract-plugin
export default {"spanStyle":"printRemark_spanStyle__uxzQz","grid":"printRemark_grid__8+6eA"};